export const UI_MODIFICATIONS_CHANGE = 'uiModificationsChange';

export const changeSource = {
	source: UI_MODIFICATIONS_CHANGE,
} as const;
